import Cookie from 'js-cookie'

export default class Visitors {
  constructor() {
    this.key = 'ijm.visited'
    this.body = document.getElementById('ijm-site')
    this.visited = Cookie.get(this.key)
    this.setup()
  }

  setup () {
    if (this.visited) {
      this.body.classList.add('state-user-visited')
    }

    if (!this.visited) {
      this.body.classList.add('state-user-not-visited')
      this.record()
    }
  }

  record () {
    Cookie.set(this.key, true, {expires: 7})
  }
}
